<template>
  <svg :class="svgClass" aria-hidden="true" @click="onClick">
    <use :xlink:href="iconName" />
  </svg>
</template>
<script>
export default {
  name: 'SvgIcon',
  props: {
    iconClass: {
      type: String,
      required: true
    },
    className: {
      type: String,
      default: ''
    },
    color: String,
    disabled: Boolean
  },
  computed: {
    iconName() {
      return `#icon-${this.iconClass}`
    },
    svgClass() {
      let classes = ['svg-icon']
      if (this.className) classes.push(this.className)
      if (this.bold) classes.push('bold')
      if (this.disabled) classes.push('disabled')
      classes.push(this.color || 'white')
      return classes.join(' ')
    }
  },
  methods: {
    onClick(evt) {
      !this.disabled && this.$emit('click', evt)
    }
  }
}
</script>

<style scoped>
.svg-icon {
  width: 1em;
  height: 1em;
  vertical-align: -0.15em;
  fill: currentColor;
  overflow: hidden;
  fill: currentColor;
}
.disabled {
  cursor: no-drop;
  color: #c0c4cc;
}
.svg-bold {
  font-weight: bold;
}
.svg-pink {
  color: #ff9b87;
}
.svg-blue {
  color: #6ebaff;
}
.svg-purple {
  color: #8190ff;
}
.svg-green {
  color: #82c36a;
}
.svg-blue-plus {
  color: #009be9;
}
.svg-yellow {
  color: #f8eb5b;
}
</style>
